var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.811 10.35a.527.527 0 0 1-.522-.454.537.537 0 0 1 .37-.589 3.182 3.182 0 0 0 2-4.376 3.21 3.21 0 0 0-2-1.734.532.532 0 0 1-.319-.252.483.483 0 0 1-.034-.4.532.532 0 0 1 .252-.32.483.483 0 0 1 .4-.034 4.236 4.236 0 0 1 0 8.128.249.249 0 0 1-.151.034ZM2.68 8.398h-.538a2.154 2.154 0 0 1-1.851-1.06 2.111 2.111 0 0 1 0-2.137 2.134 2.134 0 0 1 1.851-1.06h.538Zm6.933-8.4A.985.985 0 0 0 8.94.25L4.295 4.121v4.258L8.94 12.25a.985.985 0 0 0 .673.252 1.129 1.129 0 0 0 .757-.3 1.071 1.071 0 0 0 .319-.757V1.077A1.091 1.091 0 0 0 9.612 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.9f36eb1ef059856c1168da5adca9896f.svg";
export { ForwardRef as ReactComponent };